import { useBrPageContext } from '../context/context.js';
import { getConfiguratorDocument } from '../utils/get-configurator-document.js';
import { getSizeGuideDocument } from '../utils/get-size-guide-document.js';
import { getBrandPromotions } from '../utils/get-brand-promotions.js';
import { getPurchaseTypes } from '../utils/get-purchase-types.js';
import { getBrPageContent } from '../utils/get-br-page-content.js';

const emptyContent = {};
function useBloomreachPdpContent() {
    var ref, ref1, ref2;
    const page = useBrPageContext();
    if (!page) {
        return emptyContent;
    }
    const reference = (ref1 = (ref = page.getComponent('main')) === null || ref === void 0 ? void 0 : ref.getModels()) === null || ref1 === void 0 ? void 0 : ref1.document;
    if (!reference) {
        return emptyContent;
    }
    if (!reference.$ref) {
        return emptyContent;
    }
    const content = getBrPageContent(page, reference);
    if (!content) {
        console.warn(`Cannot find main content for ProductDetail BR page. Got: ${content} for $ref: ${reference.$ref}`);
        return emptyContent;
    }
    const { usps , instructions , noAddonsImage , additionalUsps , disclaimer , configuratorDocument: configuratorDocumentRef , sizeGuideDocument: sizeGuideDocumentRef , brandCollectionDocument , purchaseTypeContainer ,  } = content;
    const confDocContent = getBrPageContent(page, configuratorDocumentRef);
    const configuratorDocument = getConfiguratorDocument(confDocContent, noAddonsImage || undefined);
    const sizeGuideDocContent = getBrPageContent(page, sizeGuideDocumentRef);
    const sizeGuideDocument = getSizeGuideDocument(sizeGuideDocContent);
    const mainComponent = page.getComponent('main');
    const modal = getModalContent(mainComponent, page);
    const brandCollection = getBrPageContent(page, brandCollectionDocument);
    const brandPromotions = getBrandPromotions(brandCollection);
    const purchaseTypeDocument = getPurchaseTypes(purchaseTypeContainer);
    const disclaimerResult = disclaimer ? {
        name: disclaimer.name,
        displayName: disclaimer.displayName,
        title: disclaimer.title,
        description: disclaimer.description,
        contentType: disclaimer.contentType
    } : undefined;
    var ref3;
    return {
        modalContent: (ref3 = modal === null || modal === void 0 ? void 0 : (ref2 = modal.content) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref3 !== void 0 ? ref3 : '',
        instructions: instructions && {
            value: instructions.html,
            textColor: instructions.textColor,
            backgroundColor: instructions.backgroundColor
        },
        usps: usps.map(({ icon , text  })=>({
                icon,
                text
            })
        ),
        additionalUsps: additionalUsps.map(({ icon , text  })=>({
                icon,
                text
            })
        ),
        configuratorDocument,
        purchaseTypeDocument,
        brandPromotions,
        disclaimer: disclaimerResult,
        sizeGuideDocument
    };
}
function getModalContent(main, page) {
    var ref5, ref4;
    const components = (ref5 = main === null || main === void 0 ? void 0 : main.getChildren()) === null || ref5 === void 0 ? void 0 : ref5.reduce((acc, cur)=>{
        return (cur === null || cur === void 0 ? void 0 : cur.getChildren()) ? [
            ...acc,
            ...cur === null || cur === void 0 ? void 0 : cur.getChildren()
        ] : acc;
    }, []);
    const modal = (components || []).find((c)=>{
        var ref;
        return c.getName() === 'richtext' && ((ref = c.getParameters()) === null || ref === void 0 ? void 0 : ref.template) === 'modal';
    });
    return page && getBrPageContent(page, (ref4 = modal === null || modal === void 0 ? void 0 : modal.getModels()) === null || ref4 === void 0 ? void 0 : ref4.document);
}

export { useBloomreachPdpContent };
//# sourceMappingURL=use-bloomreach-pdp-content.js.map
